var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4948_12714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92099 4.12667L5.44766 1.65333C5.40099 1.60667 5.34099 1.56667 5.27433 1.54C5.26766 1.54 5.26099 1.54 5.25433 1.53333C5.20099 1.51333 5.14766 1.5 5.08766 1.5C4.95433 1.5 4.82766 1.55333 4.73433 1.64667L2.24766 4.12667C2.05433 4.32 2.05433 4.64 2.24766 4.83333C2.44099 5.02667 2.76099 5.02667 2.95433 4.83333L4.58766 3.2V14C4.58766 14.2733 4.81433 14.5 5.08766 14.5C5.36099 14.5 5.58766 14.2733 5.58766 14V3.20667L7.21433 4.83333C7.31432 4.93333 7.44099 4.98 7.56765 4.98C7.69432 4.98 7.82099 4.93333 7.92099 4.83333C8.11432 4.64 8.11432 4.32667 7.92099 4.12667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4948_12714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "currentColor",
    transform: "translate(0.800049 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.2fbb3766a49e5d89b4f0f0a34a6127cd.svg";
export { ForwardRef as ReactComponent };